import { Flame, Stethoscope, Lock, HelpCircle } from 'lucide-react';
import C from './colors';

export const EMERGENCY_META = {
  FIRE:     { label: 'Fire',            color: C.orange, Icon: Flame       },
  MEDICAL:  { label: 'Medical',         color: C.red,    Icon: Stethoscope },
  SECURITY: { label: 'Security',        color: C.purple, Icon: Lock        },
  OTHER:    { label: 'Other Emergency', color: C.amber,  Icon: HelpCircle  },
};

export const TX_ACTION_META = {
  ENTER_ZONE:        { label: 'Enter Zone',    color: '#3b82f6' },
  EXIT_ZONE:         { label: 'Exit Zone',     color: '#64748b' },
  EXIT_SITE:         { label: 'Exit Site',     color: '#475569' },
  SAFE:              { label: 'QR Safe',       color: '#22c55e' },
  NEED_HELP:         { label: 'QR Need Help',  color: '#ef4444' },
  LIVEPOB_SAFE:      { label: 'LivePOB Safe',  color: '#22c55e' },
  LIVEPOB_NEED_HELP: { label: 'LivePOB Help',  color: '#ef4444' },
  MARK_SAFE:         { label: 'Mark Safe',     color: '#22c55e' },
  MARK_EVACUATED:    { label: 'Evacuated',     color: '#f97316' },
  EVENT_RESET:       { label: 'Event Reset',   color: '#a78bfa' },
  RESET_STATUS:      { label: 'Status Reset',  color: '#a78bfa' },
  VISITOR_SIGN_IN:   { label: 'Visitor Sign In',  color: '#3b82f6' },
  VISITOR_SIGN_OUT:  { label: 'Visitor Sign Out', color: '#64748b' },
  VISITOR_ZONE_ENTER:{ label: 'Visitor Enter Zone', color: '#0ea5e9' },
  VISITOR_ZONE_EXIT: { label: 'Visitor Exit Zone',  color: '#64748b' },
  VISITOR_SAFE:      { label: 'Visitor Safe',      color: '#22c55e' },
  VISITOR_EVACUATED: { label: 'Visitor Evacuated', color: '#f97316' },
  VISITOR_NEED_HELP: { label: 'Visitor Need Help', color: '#ef4444' },
};
